<template lang="pug">
#app
  b-container.my-5
    b-row
      b-col.mb-5.mb-md-0.text-center.text-md-left(md="4")
        transition(name="slideDown")
          navigation(v-if="showNav")
      b-col(md="8")
        transition(name="slideUp")
          div(v-if="showContent")
            transition(mode="out-in", name="fade", enter-active-class="fadeInRight", leave-active-class="fadeOutLeft")
              router-view
</template>

<script>
import Navigation from "./components/Navigation.vue";

import { mapState } from "vuex";

export default {
  name: "app",
  data: () => ({
    showNav: false,
    showContent: false,
  }),
  computed: {
    ...mapState(["me"]),
  },
  components: {
    Navigation,
  },
  mounted() {
    this.showNav = true;
    this.showContent = true;
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
